<template>
    <div class="wrapper d-flex">
        <simbar-sidebar
            v-if="includeSidebar"
            :items="sidebarItems"
            :footer-items="sidebarFooterItems"
        />
        <main
            :class="{
                'wrapper-content': true,
                'include-sidebar': includeSidebar,
                'bg-light': true
            }"
        >
            <slot />
            <div class="px-4 mt-4">
                <b-alert variant="warning" :show="false">
                    <strong>AVISO</strong> - Página em construção.
                </b-alert>
            </div>
        </main>
    </div>
</template>
<script>
import SimbarSidebar from "../components/SimbarSidebar";

export default {
    name: "DashboardWrapper",
    components: { SimbarSidebar },
    props: {
        includeSidebar: {
            type: Boolean,
            required: true
        },
        sidebarFooterItems: {
            type: Array,
            required: true
        },
        sidebarItems: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper-content,
.wrapper {
    flex: 1;
}

@include media-breakpoint-up(md) {
    .wrapper-content.include-sidebar {
        margin-left: $sidebar-width;
    }
}
</style>
